import React, { PureComponent } from 'react';

// Sockets
import SocketManager, { HANDLERS } from '../lib/SocketManager';

// Layouts
import GameLayout from './GameLayout';
import Main from './Main';
import ArenaContextManager from '../components/Context/ArenaContext';

class Index extends PureComponent {
	socket = null;

	componentDidMount() {
		// Mount socket server
		SocketManager.registerHandler(HANDLERS.CONNECT, () => {
			console.log('Connected to Socket Server');
		});
		SocketManager.connect();
	}

	componentWillUnmount() {
		SocketManager.disconnect();
	}

	renderLayout() {
		const { children, pageContext } = this.props;

		if (pageContext.layout === 'game-layout') {
			return <GameLayout>{children}</GameLayout>;
		}

		return <Main isSticky={pageContext.isSticky} context={pageContext.layout}>{children}</Main>;
	}

	render() {
		return (
			<ArenaContextManager>
				{this.renderLayout()}
			</ArenaContextManager>
		);
	}
}

export default Index;
